import { useFilePreviewStore } from '@mygpt/app/chat/stores/useFilePreviewStore';
import { Table, Text, Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const TableRAGContent = () => {
  const { t } = useTranslation();
  const { partialExcelContent } = useFilePreviewStore();

  if (!partialExcelContent || partialExcelContent.length === 0) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <Loader color="blue" size="sm" />
        <Text size="sm" fw={500} mt={10}>
          {t('no_data')}
        </Text>
      </div>
    );
  }

  const headers = partialExcelContent[0];
  const data = partialExcelContent.slice(1);

  return (
    <div className="w-full h-full bg-white p-4 overflow-auto">
      <Table.ScrollContainer minWidth={300}>
        <Table striped highlightOnHover withTableBorder withColumnBorders horizontalSpacing="md">
          <Table.Thead>
            <Table.Tr>
              {headers.map((header, index) => (
                <Table.Th key={index} className="break-keep">
                  <Text fw={600} size="sm" c="dimmed">
                    {header}
                  </Text>
                </Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.map((row, rowIndex) => (
              <Table.Tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <Table.Td key={cellIndex}>
                    <Text size="sm">{String(cell)}</Text>
                  </Table.Td>
                ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </div>
  );
};
